import instance from "../axios";

export const cancelReservation = async (data) => {
    const response = await instance.post("reservations/Cancel.php", data);
    return response.data;
};

export const createReservation = async (data) => {
    const response = await instance.post("reservations/Create.php", data);
    return response.data;
};

export const createAndPay = async (data) => {
    const response = await instance.post("reservations/CreateAndPay.php", data);
    return response.data;
};

export const getAllReservations = async (data) => {
    const response = await instance.get("reservations/GetAll.php", data);
    return response.data;
};

export const getDetailReservation = async (id,partnerId) => {
    const response = await instance.get("reservations/GetDetailReservation.php?id="+id + "&partnerID=" + partnerId);
    return response.data;
}

export const getAreaImages = async (data) => {
    const response = await instance.get("reservations/GetAreaImages.php?partnerID="+data);
    return response.data;
};

export const getAreas = async (partnerId, date) => {
    const response = await instance.get("reservations/GetAreas.php?partnerID=" + partnerId + "&date=" + date);
    return response.data;
};

export const getTableGroups = async (partnerId) => {
    const response = await instance.get("reservations/GetTableGroups.php?partnerID=" + partnerId );
    return response.data;
};

export const getFinishedReservations = async (partnerId) => {
    const response = await instance.get("reservations/GetFinished.php?partnerID="+ partnerId);
    return response.data;
};

export const getOngoingReservations = async (data) => {
    const response = await instance.get("reservations/GetOngoing.php?partnerID=" + data);
    return response.data;
};

export const getByTableGroupID = async (partnerId, date,tableGroupID) => {
    const response = await instance.get("reservations/GetByTableGroupID.php?partnerID=" + partnerId + "&date=" + date + "&tableGroupID=" + tableGroupID);
    return response.data;
}
